export default {
    Animation(){
        $(function (){
            let lines = document.querySelectorAll('.line');
            let header = document.querySelector('.header');
            let lineMobile = document.querySelector('.line__mobile');
            let navLinks = document.querySelectorAll('.navbar-link');
            let cvIcon = document.querySelector('#cv-icon');
            let dropdowns = document.querySelectorAll('.uk-navbar-dropdown');
            let arabText = document.querySelector('#arab');
            lineMobile.addEventListener('click', function(){
                lineMobile.classList.toggle('nav__animation__line__mobile');
                header.classList.toggle('nav__gradient');
                //    Logo
                const image = document.querySelector('#logo');
                let res = image.src.split('/');
                res.forEach( e => { if (e == "logo.svg"){ return image.src = '/images/whiteLOGO.svg' } else { return image.src = '/images/logo.svg'; } } );

            });
            lines.forEach( e => {
                e.addEventListener('click', function() {
                    header.classList.toggle('nav__gradient');
                    navLinks.forEach(e => { e.classList.toggle('nav__animation__link') })
                    e.classList.toggle('nav__animation__line');
                    cvIcon.childNodes[1].classList.toggle('svg__white');
                    cvIcon.childNodes[3].classList.toggle('text-white');
                    arabText.classList.toggle('text-white');
                    //    Logo
                    const image = document.querySelector('#logo');
                    let res = image.src.split('/');
                    res.forEach( e => { if (e == "logo.svg"){ return image.src = '/images/whiteLOGO.svg' } else { return image.src = '/images/logo.svg'; } } );
                });
            });

            let dropbar = document.querySelector('#dropbar');
            let dropbarM = document.querySelector('#dropbarM');
            let bar = $('#dropbar');
            bar.on("beforeshow", function () {
                $('.uk-navbar-center').fadeOut();
            })
            bar.on("beforehide", function () {
                $('.uk-navbar-center').fadeIn();
            })

            // Close when clicking outside
            jQuery(document).on('click', function(event) {
                if ($(event.target).closest('.header').length === 0 && !dropbar.hidden) {
                    dropbar.classList.add('uk-animation-reverse');
                    dropbar.classList.add('uk-animation-leave');
                    dropbar.classList.add('uk-animation-slide-top');

                    dropbar.style.animationDuration = '500ms';
                    $('.uk-navbar-center').fadeIn();
                    setTimeout( e => {
                        dropbar.hidden = true;
                        dropbar.classList.remove('uk-animation-reverse');
                        dropbar.classList.remove('uk-animation-leave');
                        dropbar.classList.remove('uk-animation-slide-top');
                    }, 500 );
                    $(header).removeClass('nav__gradient');
                    navLinks.forEach(e => { e.classList.toggle('nav__animation__link') })
                    cvIcon.childNodes[1].classList.toggle('svg__white');
                    cvIcon.childNodes[3].classList.toggle('text-white');
                    arabText.classList.toggle('text-white');
                    lines.forEach( e => {
                        e.classList.toggle('nav__animation__line');
                    });
                    // Logo
                    const image = document.querySelector('#logo');
                    let res = image.src.split('/');
                    res.forEach( e => { if (e == "logo.svg"){ return image.src = '/images/whiteLOGO.svg' } else { return image.src = '/images/logo.svg'; } } );
                    event.stopPropagation();
                }
                else if ( $(event.target).closest('.header').length === 0 && !dropbarM.hidden ){
                    lineMobile.classList.toggle('nav__animation__line__mobile');
                    header.classList.toggle('nav__gradient');
                    dropbarM.classList.add('uk-animation-reverse');
                    dropbarM.classList.add('uk-animation-leave');
                    dropbarM.classList.add('uk-animation-slide-top');

                    dropbarM.style.animationDuration = '500ms';
                    setTimeout( e => {
                        dropbarM.hidden = true;
                        dropbarM.classList.remove('uk-animation-reverse');
                        dropbarM.classList.remove('uk-animation-leave');
                        dropbarM.classList.remove('uk-animation-slide-top');
                    }, 500 );
                    //    Logo
                    const image = document.querySelector('#logo');
                    let res = image.src.split('/');
                    res.forEach( e => { if (e == "logo.svg"){ return image.src = '/images/whiteLOGO.svg' } else { return image.src = '/images/logo.svg'; } } );

                }

            });

        })
    }
}
